<template>
  <div>
    <!-- 头部 -->
    <x-header />

    <!-- 内容 -->
    <div class="background">
      <section class="container info-section">
        <!-- 用户信息 -->
        <div class="top">
          <x-userinfo :userInfo="userInfo" :productInfo="productInfo"></x-userinfo>
        </div>

        <el-divider></el-divider>

        <div class="middle">
          <!-- 信息 -->
          <el-row :gutter="20">
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <div class="payment-price">
                {{ $t('recharge.payment.package') }}: {{ productInfo.title || '-' }}
              </div>
              <div class="payment-price">
                Tot. {{ productInfo.price }}
              </div>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="16" class="payment">
              <div class="payment-result">

                <div class="payment-result-msg">
                  <i class="el-alert__icon el-icon-success" v-if="isSuccess === true" />
                  <i class="el-alert__icon el-icon-error" v-else />
                  <span class="msg-content">{{ msg }}</span>

                  <p v-if="isSuccess === true">
                    Your payment has been submitted successfully!
                  </p>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>

      </section>
    </div>

    <!-- 底部 -->
    <x-footer />

  </div>
</template>

<script>
import footer from '@/views/components/footer'
import header from '@/views/components/header'
import productConfig from '@/util/product'
import { userInfo } from '@/api/user'
import userInfoComponent from '@/views/shop/components/userInfo'

export default {
  name: 'PaymentResult',
  components: {
    'x-userinfo': userInfoComponent,
    'x-footer': footer,
    'x-header': header
  },
  props: {
    msg: {
      type: String,
      default: 'success',
      required: true
    },
    isSuccess: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      hideUserInfo: false,
      userInfo: {
        uid: '',
        nickname: '',
        avatar: ''
      },
      productList: [],
      productInfo: {
        diamond: '',
        price: '',
        productId: ''
      }
    }
  },
  mounted () {
    let query = this.$route.query || {}
    this.productList = productConfig

    this.productInfo.productId = query.productId || ''
    this.productInfo = this.getProduct(this.productInfo.productId)

    if (!query.uid) {
      this.$router.push({ name: 'Home' })
    } else if (query.uid === '1') {
      this.hideUserInfo = true
    } else {
      let avatar = ''
      let userInfos = JSON.parse(window.localStorage.getItem('userinfos')) || {}
      if (userInfos[query.uid]) {
        this.userInfo.uid = query.uid
        this.userInfo.nickname = userInfos[query.uid].nickname || ''
        avatar = userInfos[query.uid].avatar || ''
        this.avatarHandle(avatar)
      } else {
        userInfo({ uid: query.uid })
          .then(({ code, data }) => {
            if (data.uid) {
              let userInfos = JSON.parse(window.localStorage.getItem('userinfos')) || {}
              userInfos[data.uid] = data
              window.localStorage.setItem('userinfos', JSON.stringify(userInfos))
              this.userInfo.uid = data.uid
              this.userInfo.nickname = data.nickname || ''
              avatar = data.avatar || ''
              this.avatarHandle(avatar)
            } else {
              this.$message({
                showClose: true,
                message: this.$t('recharge.common.user_not_found_message'),
                type: 'error'
              })
            }
            this.submitBtnDisable = false
          })
          .catch(() => {
            this.$message({
              showClose: true,
              message: 'Server err',
              type: 'error'
            })
            this.submitBtnDisable = true
          })
      }
    }
  },
  methods: {
    back () {
      this.$router.push({ name: 'Home' })
    },
    avatarHandle (userAvatar) {
      let avatar = 'none.jpg'
      if (userAvatar.startsWith('http')) {
        this.userInfo.avatar = userAvatar
      } else if (userAvatar) {
        let subfix = '.jpg'
        const avatars = userAvatar.split(':')
        if (userAvatar.startsWith('default')) {
          avatar = avatars[1] + subfix
        } else if (userAvatar.startsWith('special')) {
          subfix = '.png'
          avatar = avatars[1] + subfix
        }
        this.userInfo.avatar = require('@/assets/images/avatar/user/player_head_' + avatar)
      }
    },
    getProduct (productId) {
      let product = {}
      this.productList.forEach((item) => {
        if (item.productId === productId) {
          product = item
        }
      })
      return product
    }
  }
}
</script>

<!-- 覆盖样式 -->
<style></style>

<style scoped>
.payment {
  border-left: 1px solid #494947;
}

.background {
  background-image: url('~@/assets/images/shop/back.jpg');
  background-size: cover;
  background-position: center;
  margin-top: 86px;
  min-height: 80vh;
  padding-top: 20px;
  padding-bottom: 40px;
  margin-bottom: 0;
}

.info-section {
  color: #f6f7fa;
  padding: 10px;
  margin: 10px auto;
  max-width: 680px;
  border-radius: 10px;
  border: 1px solid #70602b;
}

.top {
  padding: 0px;
  max-width: 860px;
  width: 100%;
  margin-bottom: 10px;
  font-family: SourceHanSansCN-Regular;
}

.payment-price {
  font-weight: 500;
  font-size: 26px;
}

.payment-result-msg {
  margin-top: 30px;
  line-height: 40px;
}

.payment-result .payment-result-msg .el-icon-success {
  font-size: 34px;
  width: 40px;
  color: rgba(9, 230, 28, 0.897);
}

.payment-result .payment-result-msg .el-icon-error {
  font-size: 34px;
  width: 40px;
  color: #f56c6c;
}

.payment-result .payment-result-msg .msg-content {
  font-family: SourceHanSansCN-Regular;
  font-size: 34px;
  font-weight: bold;
  font-stretch: normal;
  line-height: 24px;
  letter-spacing: 0px;
}

@media only screen and (max-width: 860px) {
  .info-section {
    max-width: 800px;
  }

  .top {
    max-width: 800px;
  }
}

@media only screen and (max-width: 768px) {
  .background {
    padding: 5px 5px;
  }

  .info-section {
    padding: 5px;
    max-width: 680px;
  }

  .top {
    max-width: 680px;
  }

  .payment {
    margin-top: 10px;
    border-left: 0;
  }

  .payment-result .payment-result-msg .msg-content {
    font-size: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/shop/components/paymentResult.vue